import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyB-rSWd_H0PiahZsqJOLvRYsIPvHEdHxTc",
  authDomain: "hivemind-15256.firebaseapp.com",
  projectId: "hivemind-15256",
  storageBucket: "hivemind-15256.firebasestorage.app",
  messagingSenderId: "651193484928",
  appId: "1:651193484928:web:e8c9976adc58c7a7198865",
  measurementId: "G-GP39DB17J9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Services
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);

export default app;
